import { apiPost } from './api';

export async function powerOff(): Promise<{ ok: boolean }> {
  return apiPost<{ ok: boolean }>('/user/system/power_off');
}
